(() => {
  if (window.HBMobileFilters || !('HTMLDialogElement' in window)) return;
  const configNode = document.getElementById('hb-mobile-filters-labels');
  if (!configNode) return;
  const words = JSON.parse(configNode.textContent);
  const mobile = matchMedia('(max-width:749px)');
  const selector = '[data-hb-filters-version] form:has(select[data-hb-param="sort_by"])';
  let dialog, active, scheduled = false, sequence = 0;
  const data = new WeakMap();
  function node(tag, cls, text) {
    const el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text !== undefined) el.textContent = text;
    return el;
  }
  function button(cls, text) {
    const el = node('button', cls, text);
    el.type = 'button';
    return el;
  }
  function count(form) {
    const first = form.closest('[data-hb-filters-version]')?.querySelector(':scope > p:first-child');
    return first?.textContent.trim() || '';
  }
  function currentForm() {
    if (active?.form.isConnected) return active.form;
    return active?.host?.querySelector(selector) || null;
  }
  function field(form, name) {
    return Array.from(form.querySelectorAll('select[data-hb-param]')).find(el => el.dataset.hbParam === name);
  }
  function label(select) {
    const wrapper = select.closest('label');
    if (!wrapper) return select.getAttribute('aria-label') || select.name;
    const copy = wrapper.cloneNode(true);
    copy.querySelectorAll('select,input').forEach(el => el.remove());
    return copy.textContent.trim();
  }
  function init(form) {
    if (data.has(form)) return;
    const bar = node('div', 'hb-mf-bar');
    const opener = button('hb-mf-open');
    const icon = document.createElementNS('http://www.w3.org/2000/svg','svg');
    icon.setAttribute('viewBox','0 0 20 20');
    icon.setAttribute('aria-hidden','true');
    const path = document.createElementNS(icon.namespaceURI,'path');
    path.setAttribute('d','M1 5h4m4 0h10M1 15h10m4 0h4M9 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m6 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0');
    icon.append(path);
    opener.append(icon,node('span','',words.title));
    opener.setAttribute('aria-haspopup','dialog');
    opener.setAttribute('aria-expanded','false');
    const total = node('span','hb-mf-count',count(form));
    bar.append(opener,total);
    form.before(bar);
    form.dataset.hbMobileFilterSource = '';
    const record = {form,bar,opener,total,host:form.closest('[data-hb-filters-version]').parentElement};
    data.set(form,record);
    opener.addEventListener('click',()=>open(record));
  }
  function createDialog() {
    dialog = node('dialog','hb-mf-dialog');
    dialog.id = 'hb-mobile-filter-dialog';
    dialog.setAttribute('aria-labelledby','hb-mobile-filter-title');
    dialog.setAttribute('aria-modal','true');
    dialog.addEventListener('cancel',()=>dialog.close());
    dialog.addEventListener('close',()=>{
      const source = currentForm();
      data.get(source)?.opener?.setAttribute('aria-expanded','false');
      data.get(source)?.opener?.focus({preventScroll:true});
      active = null;
    });
    dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
    document.body.append(dialog);
  }
  function change(name,value) {
    const source = currentForm();
    const original = source && field(source,name);
    if (!original || original.value===value) return;
    active.focus = {name,value};
    original.value = value;
    original.dispatchEvent(new Event('change',{bubbles:true}));
    schedule();
  }
  function render(form) {
    const expanded = new Set(Array.from(dialog.querySelectorAll('details[open]')).map(el=>el.dataset.param));
    const focus = active.focus;
    dialog.replaceChildren();
    const head = node('div','hb-mf-head');
    const title = node('h2','hb-mf-title',words.title);
    title.id = 'hb-mobile-filter-title';
    const close = button('hb-mf-close','×');
    close.setAttribute('aria-label',words.close);
    close.addEventListener('click',()=>dialog.close());
    head.append(title,node('p','hb-mf-total',count(form)),close);
    const content = node('div','hb-mf-content');
    for (const source of form.querySelectorAll('select[data-hb-param]')) {
      const name = source.dataset.hbParam;
      if (name==='sort_by') {
        const sort = node('label','hb-mf-sort');
        sort.append(node('span','',words.sort));
        const select = source.cloneNode(true);
        select.removeAttribute('id');
        select.removeAttribute('name');
        select.removeAttribute('data-hb-param');
        select.dataset.mfParam = name;
        select.value = source.value;
        select.addEventListener('change',()=>change(name,select.value));
        sort.append(select);
        content.append(sort);
        continue;
      }
      const group = node('details','hb-mf-group');
      group.dataset.param=name;
      group.open=expanded.has(name);
      const summary=node('summary','');
      const arrow=node('span','hb-mf-arrow','→');arrow.setAttribute('aria-hidden','true');
      summary.append(node('span','',label(source)),arrow);
      const options=node('fieldset','hb-mf-options');
      options.setAttribute('aria-label',label(source));
      const radioName='hb-mf-option-'+(++sequence);
      for (const option of source.options) {
        const item=node('label','hb-mf-option');
        const radio=node('input','');
        radio.type='radio';radio.name=radioName;radio.value=option.value;
        radio.checked=option.value===source.value;radio.disabled=option.disabled;
        radio.dataset.mfParam=name;
        radio.addEventListener('change',()=>{if(radio.checked)change(name,radio.value);});
        item.append(radio,node('span','',option.textContent));
        options.append(item);
      }
      group.append(summary,options);
      content.append(group);
    }
    const status=node('p','hb-mf-status');status.setAttribute('role','status');status.setAttribute('aria-live','polite');
    content.append(status);
    const foot=node('div','hb-mf-foot');
    const reset=button('hb-mf-reset',words.reset);
    reset.addEventListener('click',()=>{
      const source=currentForm();
      const link=source?.querySelector('a[href]');
      active.focus=null;
      link?.click();
      schedule();
    });
    const apply=button('hb-mf-apply',words.apply);
    apply.addEventListener('click',()=>{
      const source=currentForm();
      const panel=source?.closest('section[data-collection-url]');
      if (panel?.querySelector(':scope > [role="status"][data-error="true"]'))source.requestSubmit();
      else dialog.close();
    });
    foot.append(reset,apply);
    dialog.append(head,content,foot);
    active.form=form;
    if (focus && dialog.open) {
      const control=Array.from(dialog.querySelectorAll('[data-mf-param]')).find(el=>el.dataset.mfParam===focus.name && (el.tagName==='SELECT'||el.value===focus.value));
      control?.focus({preventScroll:true});
    }
  }
  function updateStatus(form) {
    const panel=form.closest('section[data-collection-url]');
    const busy=panel?.getAttribute('aria-busy')==='true';
    const error=panel?.querySelector(':scope > [role="status"][data-error="true"]');
    const text=error?.textContent || (busy?words.loading:'');
    const status=dialog.querySelector('.hb-mf-status');
    if(status.textContent!==text)status.textContent=text;
    dialog.setAttribute('aria-busy',String(busy));
  }
  function open(record) {
    if (!mobile.matches) return;
    if (!dialog) createDialog();
    active={...record,focus:null};
    record.opener.setAttribute('aria-expanded','true');
    record.opener.setAttribute('aria-controls',dialog.id);
    render(record.form);
    dialog.showModal();
    updateStatus(record.form);
  }
  function scan() {
    if (!mobile.matches) {
      if(dialog?.open)dialog.close();
      document.querySelectorAll(selector).forEach(form=>{
        data.get(form)?.bar.remove();
        form.removeAttribute('data-hb-mobile-filter-source');
        data.delete(form);
      });
      return;
    }
    document.querySelectorAll(selector).forEach(form=>{
      init(form);
      const record=data.get(form),total=count(form);
      if(record.total.textContent!==total)record.total.textContent=total;
    });
    if(dialog?.open && active){
      const form=currentForm();
      if(form && form!==active.form)render(form);
      if(form)updateStatus(form);
      else if(!active.host.isConnected)dialog.close();
    }
  }
  function schedule() {
    if(scheduled)return;
    scheduled=true;
    requestAnimationFrame(()=>{scheduled=false;scan();});
  }
  const observer=new MutationObserver(records=>{
    if(!mobile.matches)return;
    if(records.some(record=>{
      const target=record.target instanceof Element?record.target:record.target.parentElement;
      return !target?.closest('.hb-mf-dialog,.hb-mf-bar');
    }))schedule();
  });
  observer.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['aria-busy','data-error']});
  mobile.addEventListener('change',schedule);
  document.addEventListener('shopify:section:load',schedule);
  window.HBMobileFilters={refresh:schedule};
  scan();
})();

